import logo from 'assets/integrations/helpscout/logo.svg';

export default {
  slug: 'helpscout',
  name: 'Help Scout',
  summary: 'Link Help Scout conversations to Opteria.io backlog items.',
  logo: logo
};
